/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CallForOpportunity } from '../models/call-for-opportunity';
import { CallForOpportunityMatches } from '../models/call-for-opportunity-matches';
import { CallForOpportunityPagedData } from '../models/call-for-opportunity-paged-data';
import { CallForOpportunityPublish } from '../models/call-for-opportunity-publish';
import { createCallForOpportunity } from '../fn/call-for-opportunity/create-call-for-opportunity';
import { CreateCallForOpportunity$Params } from '../fn/call-for-opportunity/create-call-for-opportunity';
import { deleteCallForOpportunity } from '../fn/call-for-opportunity/delete-call-for-opportunity';
import { DeleteCallForOpportunity$Params } from '../fn/call-for-opportunity/delete-call-for-opportunity';
import { getCallForOpportunities } from '../fn/call-for-opportunity/get-call-for-opportunities';
import { GetCallForOpportunities$Params } from '../fn/call-for-opportunity/get-call-for-opportunities';
import { getCallForOpportunity } from '../fn/call-for-opportunity/get-call-for-opportunity';
import { GetCallForOpportunity$Params } from '../fn/call-for-opportunity/get-call-for-opportunity';
import { getCallForOpportunityMatches } from '../fn/call-for-opportunity/get-call-for-opportunity-matches';
import { GetCallForOpportunityMatches$Params } from '../fn/call-for-opportunity/get-call-for-opportunity-matches';
import { getPublicCallForOpportunities } from '../fn/call-for-opportunity/get-public-call-for-opportunities';
import { GetPublicCallForOpportunities$Params } from '../fn/call-for-opportunity/get-public-call-for-opportunities';
import { updateCallForOpportunity } from '../fn/call-for-opportunity/update-call-for-opportunity';
import { UpdateCallForOpportunity$Params } from '../fn/call-for-opportunity/update-call-for-opportunity';

@Injectable({ providedIn: 'root' })
export class CallForOpportunityService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getCallForOpportunities()` */
  static readonly GetCallForOpportunitiesPath = '/callforopportunity';

  /**
   * [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCallForOpportunities()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCallForOpportunities$Response(params?: GetCallForOpportunities$Params, context?: HttpContext): Observable<StrictHttpResponse<CallForOpportunityPagedData>> {
    const obs = getCallForOpportunities(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCallForOpportunities$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCallForOpportunities(params?: GetCallForOpportunities$Params, context?: HttpContext): Observable<CallForOpportunityPagedData> {
    const resp = this.getCallForOpportunities$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<CallForOpportunityPagedData>): CallForOpportunityPagedData => r.body)
    );
  }

  /** Path part for operation `createCallForOpportunity()` */
  static readonly CreateCallForOpportunityPath = '/callforopportunity';

  /**
   * [policies: Student].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createCallForOpportunity()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createCallForOpportunity$Response(params?: CreateCallForOpportunity$Params, context?: HttpContext): Observable<StrictHttpResponse<(CallForOpportunity | CallForOpportunityMatches)>> {
    const obs = createCallForOpportunity(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * [policies: Student].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createCallForOpportunity$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createCallForOpportunity(params?: CreateCallForOpportunity$Params, context?: HttpContext): Observable<(CallForOpportunity | CallForOpportunityMatches)> {
    const resp = this.createCallForOpportunity$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<(CallForOpportunity | CallForOpportunityMatches)>): (CallForOpportunity | CallForOpportunityMatches) => r.body)
    );
  }

  /** Path part for operation `getCallForOpportunity()` */
  static readonly GetCallForOpportunityPath = '/callforopportunity/{id}';

  /**
   * [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCallForOpportunity()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCallForOpportunity$Response(params: GetCallForOpportunity$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<(CallForOpportunity | CallForOpportunityMatches)>>> {
    const obs = getCallForOpportunity(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * [policies: AuthenticatedUser].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCallForOpportunity$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCallForOpportunity(params: GetCallForOpportunity$Params, context?: HttpContext): Observable<Array<(CallForOpportunity | CallForOpportunityMatches)>> {
    const resp = this.getCallForOpportunity$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<(CallForOpportunity | CallForOpportunityMatches)>>): Array<(CallForOpportunity | CallForOpportunityMatches)> => r.body)
    );
  }

  /** Path part for operation `updateCallForOpportunity()` */
  static readonly UpdateCallForOpportunityPath = '/callforopportunity/{id}';

  /**
   * [policies: Owner].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateCallForOpportunity()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateCallForOpportunity$Response(params: UpdateCallForOpportunity$Params, context?: HttpContext): Observable<StrictHttpResponse<(CallForOpportunity | CallForOpportunityMatches)>> {
    const obs = updateCallForOpportunity(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * [policies: Owner].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateCallForOpportunity$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateCallForOpportunity(params: UpdateCallForOpportunity$Params, context?: HttpContext): Observable<(CallForOpportunity | CallForOpportunityMatches)> {
    const resp = this.updateCallForOpportunity$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<(CallForOpportunity | CallForOpportunityMatches)>): (CallForOpportunity | CallForOpportunityMatches) => r.body)
    );
  }

  /** Path part for operation `deleteCallForOpportunity()` */
  static readonly DeleteCallForOpportunityPath = '/callforopportunity/{id}';

  /**
   * [policies: Owner].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteCallForOpportunity()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteCallForOpportunity$Response(params: DeleteCallForOpportunity$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = deleteCallForOpportunity(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * [policies: Owner].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteCallForOpportunity$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteCallForOpportunity(params: DeleteCallForOpportunity$Params, context?: HttpContext): Observable<void> {
    const resp = this.deleteCallForOpportunity$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getCallForOpportunityMatches()` */
  static readonly GetCallForOpportunityMatchesPath = '/matchesforcompany/{companyId}';

  /**
   * [policies: Company].
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCallForOpportunityMatches()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCallForOpportunityMatches$Response(params: GetCallForOpportunityMatches$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CallForOpportunityMatches>>> {
    const obs = getCallForOpportunityMatches(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * [policies: Company].
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCallForOpportunityMatches$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCallForOpportunityMatches(params: GetCallForOpportunityMatches$Params, context?: HttpContext): Observable<Array<CallForOpportunityMatches>> {
    const resp = this.getCallForOpportunityMatches$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<CallForOpportunityMatches>>): Array<CallForOpportunityMatches> => r.body)
    );
  }

  /** Path part for operation `getPublicCallForOpportunities()` */
  static readonly GetPublicCallForOpportunitiesPath = '/publiccallforopportunities';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getPublicCallForOpportunities()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPublicCallForOpportunities$Response(params?: GetPublicCallForOpportunities$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CallForOpportunityPublish>>> {
    const obs = getPublicCallForOpportunities(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getPublicCallForOpportunities$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getPublicCallForOpportunities(params?: GetPublicCallForOpportunities$Params, context?: HttpContext): Observable<Array<CallForOpportunityPublish>> {
    const resp = this.getPublicCallForOpportunities$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<CallForOpportunityPublish>>): Array<CallForOpportunityPublish> => r.body)
    );
  }

}
